import { Card, Typography, Input, Button, Form, Divider, Select, Tag } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import * as Validation from "../../../utils/helper/validation";
import * as Apis from "../../../utils/helper/enum";
import { changeLoader } from "../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { jwtDecode } from "jwt-decode";
import { addDeleteGetLocalStorage, storageKeys } from "../../../utils/global/localData";
import { checkPermissionAction } from "../../../utils/helper/utils";

const CreateSubAdmin = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
    }
    if (id) {
      if (!checkPermissionAction("Manage Sub Admin", permissionJson, "edit")) {
        navigate("/manage-sub-admin");
      }
    } else {
      if (!checkPermissionAction("Manage Sub Admin", permissionJson, "add")) {
        navigate("/manage-sub-admin");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [selectRoles, setSelectRoles] = useState([]);
  const [selectVendors, setSelectVendor] = useState([]);
  const [selectBranches, setSelectBranches] = useState([]);
  const [selectDropZones, setSelectDropZones] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);

  const [branches, setBranches] = useState([]);
  const [dropzones, setDropzones] = useState([]);
  const [isBranchDisabled, setIsBranchDisabled] = useState(false);
  const [isDropzoneDisabled, setIsDropzoneDisabled] = useState(false);
  const [backupBranches, setBackupBranches] = useState([]);
  const [backupDropzones, setBackupDropzones] = useState([]);
  const isAllVendorSelected = selectedVendor === "all";

  //Get Subadmin Data
  const getRolesData = async () => {
    dispatch(changeLoader(true));
    let response = await globalRequest(Apis.MANAGE_SUBADMIN.GET_ALL_ROLE, "get", {}, {}, true);
    if (response?.status === 200) {
      let data = response?.data?.data;
      let roleData = [];
      if (data && data.length > 0)
        for (let item of data) {
          roleData.push({
            value: item.id,
            label: item.subadminRoleName,
          });
        }
      setSelectRoles(roleData);
      if (id) getSubadminData();
    } else {
      // toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  };

  //Get vendor Data
  const getVendorData = async () => {
    dispatch(changeLoader(true));
    let response = await globalRequest(Apis.MANAGE_SUBADMIN.GET_ALL_VENDOR, "get", {}, {}, true);
    if (response?.status === 200) {
      let data = response?.data?.data;
      let vendorData = [{ value: "all", label: "All" },];
      if (data && data.length > 0)
        for (let item of data) {
          vendorData.push({
            value: item?.id,
            label: item?.vendorDetail?.storeName,
          });
        }
      setSelectVendor(vendorData);
    } else {
      // toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  };

  //Get Branch Data
  const getBranchData = async (id) => {
  dispatch(changeLoader(true));
  let response = await globalRequest(Apis.MANAGE_SUBADMIN.GET_ALL_BRNACH + "/" + id, "get", {}, {}, true);
  if (response?.status === 200) {
    let data = response?.data?.data;
    let list = [{ value: "all", label: "All" }];
    if (data?.length > 0) {
      for (let item of data) {
        list.push({ 
          value: item.id, 
          label: item.name,
        });
      }
    }
    setSelectBranches(list);
    dispatch(changeLoader(false));
    return list;
  }
  dispatch(changeLoader(false));
  return [];
};

  const removeItem = (value) => {
    if (value === "all") {
      setBranches([]);
    } else {
      setBranches((prev) => prev.filter((branch) => branch.value !== value));
    }
  };

  const removeDropzone = (value) => {
    setDropzones((prev) => prev.filter((dropzone) => dropzone.value !== value));
  };

const handleVendorChange = async (value) => {
  setSelectedVendor(value);

  if (value === "all") {

    setBackupBranches(branches);
    setBackupDropzones(dropzones);

    setBranches([]);
    setDropzones([]);
    form.setFieldValue("branch_ids", []);
    form.setFieldValue("dropzone_ids", []);

    setIsBranchDisabled(true);
    setIsDropzoneDisabled(true);
    return;
  }

  if (selectedVendor === "all") {
    setBranches(backupBranches);
    setDropzones(backupDropzones);
    form.setFieldValue("branch_ids", backupBranches.map(b => b.value));
    form.setFieldValue("dropzone_ids", backupDropzones.map(d => d.value));
  }

    setIsBranchDisabled(false);
    setIsDropzoneDisabled(false);
    await getBranchData(value);
};

   //Get Dropzone Data
  const getDropZoneData = async (id) => {
    dispatch(changeLoader(true));
    let response = await globalRequest(Apis.MANAGE_SUBADMIN.GET_ALL_DROPZONES, "get", {}, {}, true);
    if (response?.status === 200) {
      let data = response?.data?.data;
      let roleData = [{ value: "all", label: "All" }];
      if (data && data.length > 0)
        for (let item of data) {
          roleData.push({
            value: item.dropZoneId,
            label: item.name,
          });
        }
      setSelectDropZones(roleData);
    } else {
      // toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  };


  //Get Subadmin Data
  const getSubadminData = async () => {
    dispatch(changeLoader(true));
    let response = await globalRequest(Apis.MANAGE_SUBADMIN.GET_DETAIL + "/" + id, "get", {}, {}, true);
    if (response?.status === 200) {
      let data = response?.data?.data;
      form.setFieldValue("first_name", data?.firstName);
      form.setFieldValue("last_name", data?.lastName);
      form.setFieldValue("email", data?.email);
      let mobile = (data?.mobileNo).split("-");
      form.setFieldValue("mobile_no", mobile[1]);
      form.setFieldValue("role_id", data?.rolePermissionId);

      if ((!data?.subadminDetail?.branchData || data.subadminDetail.branchData.length === 0) 
        && (!data?.subadminDetail?.dropZoneData || data.subadminDetail.dropZoneData.length === 0)) {
        setSelectedVendor("all");
        form.setFieldValue("vendor_id", "all");
        setIsBranchDisabled(true); 
        setIsDropzoneDisabled(true);
      } else {
        setIsBranchDisabled(false);
        setIsDropzoneDisabled(false);
      }
        if (data?.subadminDetail?.branchData?.length > 0) {
        let items = [];
        for (let item of data?.subadminDetail?.branchData) {
          items.push({ value: item.id, label: item.name });
        }
        setBranches(items);
      }
      if (data?.subadminDetail?.dropZoneData?.length > 0) {
        let dropZoneList = [];
        for (let item of data?.subadminDetail?.dropZoneData) {
          dropZoneList.push({ value: item.id, label: item.name });
        }
        setDropzones(dropZoneList);
      }
    } else {
      // toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getRolesData();
    getVendorData();
    getDropZoneData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (values) => {
    if (values?.errorFields?.length > 0) return;

    if (!isAllVendorSelected && (!branches || branches.length === 0) && (!dropzones || dropzones.length === 0)) {
      toast.error("You need to select at least 1 branch or dropzone.");
      return false;
    }

    let branchIdes = [];
    let dropZoneIds = [];
    if (branches.length > 0) {
      for (let row of branches) {
        branchIdes.push(row.value);
      }
    }
    if (dropzones.length > 0) {
      for (let row of dropzones) {
        dropZoneIds.push(row.value);
      }
    }
    values.branch_ids = branchIdes;
    values.dropzone_ids = dropZoneIds
    values.status = "active";

    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_SUBADMIN?.CREATE;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_SUBADMIN?.EDIT + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Subadmin created successfully";
        if (id) msg = "Subadmin updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-sub-admin");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  return (
    <>
      <Card>
        <Typography className="text-xl font-semibold" align={"left"}>
          <LeftOutlined onClick={() => navigate(-1)} className="text=lg text-black mr-2 cursor-pointer" />
          {id ? "Edit" : "Add"} Sub Admin Account
        </Typography>
        <Divider />
        <div className="min-h-[calc(100vh_-_305px)]">
          <Form
            form={form}
            onFinish={handleSubmit}
            onFinishFailed={handleSubmit}
            layout="vertical"
            style={{
              maxWidth: 600,
              width: "100%",
            }}
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
          >
            <Form.Item
              label="First Name"
              name="first_name"
              rules={[
                {
                  required: true,
                  message: "Please enter your First Name.",
                },
                {
                  max: 20,
                  message: "Maximum 20 characters",
                },
              ]}
            >
              <Input
                size="large"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "text");
                  form.setFieldValue("first_name", value.trimStart());
                  handleInputChange("first_name");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Last Name"
              name="last_name"
              rules={[
                {
                  required: true,
                  message: "Please enter your Last Name.",
                },
                {
                  max: 20,
                  message: "Maximum 20 characters",
                },
              ]}
            >
              <Input
                size="large"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "text");
                  form.setFieldValue("last_name", value.trimStart());
                  handleInputChange("last_name");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Email Address"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please enter your Email Address.",
                },
                {
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Please enter a valid email address.",
                },
              ]}
              validateTrigger={"onSubmit"}
            >
              <Input
                disabled={id ? true : false}
                size="large"
                onChange={(e) => {
                  form.setFieldValue("email", e.target.value.trimStart());
                  handleInputChange("email");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Mobile Number"
              name="mobile_no"
              rules={[
                {
                  required: true,
                  message: "Please enter your Driver Mobile No.",
                },
                {
                  min: 9,
                  message: "Mobile number must be 9 digits",
                },
                {
                  max: 9,
                  message: "Mobile number must be no more than 9 digits",
                },
              ]}
              validateTrigger={"onSubmit"}
            >
              <Input
                size="large"
                addonBefore={<span>+966</span>}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number|max:9");
                  form.setFieldValue("mobile_no", value.trimStart());
                  handleInputChange("mobile_no");
                }}
              />
            </Form.Item>

            <Form.Item
              label="Role"
              name="role_id"
              rules={[
                {
                  required: true,
                  message: "Please select your Role.",
                },
              ]}
            >
              <Select
                size="large"
                placeholder="Select"
                options={selectRoles}
                showSearch
                filterOption={(input, selectRoles) => (selectRoles?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                onChange={(value) => {
                  form.setFieldValue("role_id", value);
                  handleInputChange("role_id");
                }}
              />
            </Form.Item>
            <Form.Item label="Vendor">
              <Select
                size="large"
                placeholder="Select"
                options={selectVendors}
                value={selectedVendor}
                showSearch
                filterOption={(input, selectVendors) => (selectVendors?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                onChange={handleVendorChange}
              />
            </Form.Item>
            <Form.Item label="Branch">
              <Select
                size="large"
                placeholder="Select"
                options={selectBranches}
                showSearch
                disabled={isBranchDisabled}
                value={undefined}
                onChange={(value) => {
                  if (value === "all") {
                    const allBranches = selectBranches
                      .filter(b => b.value !== "all")
                      .map(b => ({ value: b.value, label: b.label }));

                    const merged = [...branches, ...allBranches.filter(b => !branches.some(x => x.value === b.value))];

                    setBranches(merged);
                    form.setFieldValue("branch_ids", merged.map(b => b.value));
                    return;
                  }

                  const selected = selectBranches.find(b => b.value === value);

                  if (!branches.some(b => b.value === selected.value)) {
                  const merged = [...branches, selected];
                  setBranches(merged);
                  form.setFieldValue("branch_ids", merged.map(b => b.value));
                  }
                }}
              />
              <div className="flex flex-wrap my-2">
                {branches.map(item => (
                  <Tag key={item.value} closable bordered={false} onClose={() => removeItem(item.value)}>
                    {item.label}
                  </Tag>
                ))}
              </div>
            </Form.Item>
             <Form.Item label="Dropzone">
              <Select
                size="large"
                placeholder="Select"
                options={selectDropZones}
                showSearch
                disabled={isDropzoneDisabled}
                value={undefined}
                onChange={(value) => {

                  if (value === "all") {
                    const allDZ = selectDropZones
                      .filter(d => d.value !== "all")
                      .map(d => ({ value: d.value, label: d.label }));

                    const merged = [...dropzones, ...allDZ.filter(d => !dropzones.some(x => x.value === d.value))];

                    setDropzones(merged);
                    form.setFieldValue("dropzone_ids", merged.map(d => d.value));
                    return;
                  }

                  const selected = selectDropZones.find(d => d.value === value);

                  if (!dropzones.some(d => d.value === selected.value)) {
                  const merged = [...dropzones, selected];
                  setDropzones(merged);
                  form.setFieldValue("dropzone_ids", merged.map(d => d.value));
                  }
                }}
              />
              <div className="flex flex-wrap my-2">
                {dropzones?.map(item => (
                  <Tag
                    key={item.value} closable bordered={false} onClose={() => removeDropzone(item.value)}>
                    {item.label}
                  </Tag>
                ))}
              </div>
            </Form.Item>
          </Form>
        </div>
        <Divider />
        <div className="flex justify-end gap-3">
          <Button onClick={() => navigate("/manage-sub-admin")}>Cancel</Button>
          <Button type="primary" htmlType="submit" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      </Card>
    </>
  );
};
export default CreateSubAdmin;
